<!-- Full-page overlay spinner -->
@if (overlay) {
  <div class="spinner-overlay">
    <div class="spinner-overlay-content">
      <div [class]="spinnerClass" role="status">
        <span class="visually-hidden">{{ srText }}</span>
      </div>
      @if (label) {
        <div class="spinner-label mt-3">{{ label }}</div>
      }
    </div>
  </div>
}

<!-- Centered spinner -->
@if (centered && !overlay) {
  <div class="spinner-centered">
    <div [class]="spinnerClass" role="status">
      <span class="visually-hidden">{{ srText }}</span>
    </div>
    @if (label) {
      <div class="spinner-label mt-2">{{ label }}</div>
    }
  </div>
}

<!-- Inline spinner -->
@if (!centered && !overlay) {
  <span class="spinner-inline">
    <span [class]="spinnerClass" role="status">
      <span class="visually-hidden">{{ srText }}</span>
    </span>
    @if (label) {
      <span class="spinner-label ms-2">{{ label }}</span>
    }
  </span>
}
